export class FilterConstant {

    static YOE_TYPE = {
        TOTAL: "Total", AVG: "Average", CURRENT: "Current"
    };

    static FILTER_NAMES = {
        KEYWORD: "keyword",
        OVERALL_MATCH: "overall_match",
        JOB_TITLE: "job_title",
        LOCATION: "location",
        SKILLS: "skills",
        COMPANY: "company",
        COMPANY_SIZE: "company_size",
        INDUSTRIES: "industries",
        FUNCTIONS: "functions",
        SENIORITY: "seniority",
        YEARS_OF_EXPERIENCE: "years_of_experience",
        YEARS_OF_EXPERIENCE_CURRENT_COMPANY: "years_of_experience_current_company",
        GENDER: "gender",
        EDUCATION: "education",
        SCHOOL: "school",
        FIELD_OF_STUDY: "field_of_study",
        LIKELY_TO_MOVE_IN: "likely_to_move_in",
        CHANGED_JOB: "changedjob",
        PAST_JOB_TITLE: "pastjobtitle",
        KEYWORD_INPUT: "keyword_input",
        EDUCATION_LOCATION: "school_location",
        DISTANCE: "distance",
        HIGHLIGHTS: "highlights",
        POSITION_HIERARCHY: "position_hierarchy",
        GRADUATION_YEAR: "graduationyear",
        FULL_NAME: 'fullname',
        WEBBTREE_TRUE_LEVEL: 'webbtree_true_level',
        NAME_WITH_LINKEDIN_URL: 'name_with_linkedin_url'
    };  

    /**Use to give filter access for uploadcandidate and inbound candidate*/
    static PROJECT_UPLOAD_CANDIDATE_APPLICABLE_FILTER_MODEL = new Set([
        FilterConstant.FILTER_NAMES.JOB_TITLE,
        FilterConstant.FILTER_NAMES.PAST_JOB_TITLE,
        FilterConstant.FILTER_NAMES.YEARS_OF_EXPERIENCE,
        FilterConstant.FILTER_NAMES.YEARS_OF_EXPERIENCE_CURRENT_COMPANY,
        FilterConstant.FILTER_NAMES.COMPANY,
        FilterConstant.FILTER_NAMES.SKILLS,
        FilterConstant.FILTER_NAMES.LOCATION,
        FilterConstant.FILTER_NAMES.EDUCATION,
        FilterConstant.FILTER_NAMES.SCHOOL,
        FilterConstant.FILTER_NAMES.FIELD_OF_STUDY,
        FilterConstant.FILTER_NAMES.EDUCATION_LOCATION,
        FilterConstant.FILTER_NAMES.GRADUATION_YEAR,
        FilterConstant.FILTER_NAMES.FULL_NAME
    ]);

    static PROJECT_SEARCH_CANDIDATE_APPLICABLE_FILTER_MODEL = new Set([
        FilterConstant.FILTER_NAMES.JOB_TITLE,
        FilterConstant.FILTER_NAMES.LOCATION,
        FilterConstant.FILTER_NAMES.SKILLS,
        FilterConstant.FILTER_NAMES.COMPANY,
        FilterConstant.FILTER_NAMES.COMPANY_SIZE,
        FilterConstant.FILTER_NAMES.INDUSTRIES,
        FilterConstant.FILTER_NAMES.FUNCTIONS,
        FilterConstant.FILTER_NAMES.YEARS_OF_EXPERIENCE,
        FilterConstant.FILTER_NAMES.YEARS_OF_EXPERIENCE_CURRENT_COMPANY,
        FilterConstant.FILTER_NAMES.LIKELY_TO_MOVE_IN,
        FilterConstant.FILTER_NAMES.SCHOOL,
        FilterConstant.FILTER_NAMES.EDUCATION,
        FilterConstant.FILTER_NAMES.GENDER,
        FilterConstant.FILTER_NAMES.SENIORITY,
        FilterConstant.FILTER_NAMES.FIELD_OF_STUDY,
        FilterConstant.FILTER_NAMES.CHANGED_JOB,
        FilterConstant.FILTER_NAMES.PAST_JOB_TITLE,
        FilterConstant.FILTER_NAMES.EDUCATION_LOCATION,
        FilterConstant.FILTER_NAMES.KEYWORD_INPUT,
        FilterConstant.FILTER_NAMES.DISTANCE,
        FilterConstant.FILTER_NAMES.HIGHLIGHTS,
        FilterConstant.FILTER_NAMES.POSITION_HIERARCHY,
        FilterConstant.FILTER_NAMES.GRADUATION_YEAR,
        FilterConstant.FILTER_NAMES.FULL_NAME,
        FilterConstant.FILTER_NAMES.WEBBTREE_TRUE_LEVEL,
        FilterConstant.FILTER_NAMES.NAME_WITH_LINKEDIN_URL
    ]);












}

